<div class="p-2">
    <h2>Role and Permission Management</h2>
    <p class="purple-sub-title">Define and manage user roles and permissions across the system.</p>

    <!-- Global Roles Section -->
    @if (currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN') {
    <div class="card mb-4">
        <div class="flex justify-between items-center mb-3">
            <h3>Global Roles</h3>
            <button pButton label="Add Custom Role" icon="pi pi-plus" (click)="openDrawer(null, 'add')" *ngIf="canAddCustomRole() && (!(hasSelectedSubscription()))" class="md:w-auto w-full md:p-button-sm"></button>
        </div>

        <p-table [value]="globalRoles" [tableStyle]="{'min-width': '50rem'}" [loading]="globalRolesLoading" [showLoader]="true">
            <ng-template pTemplate="header">
                <tr>
                    <th>ROLE NAME</th>
                    <th>LEVEL</th>
                    <th>USERS</th>
                    <th>ACTIONS</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-role>
                <tr>
                    <td>{{ role.name }}</td>
                    <td>
                        <p-tag [value]="role.level" severity="danger"></p-tag>
                    </td>
                    <td>{{ role.userCount || 0 }}</td>
                    <td>
                        <button pButton icon="pi pi-eye" (click)="openDrawer(role, 'view')" class="p-button-text"></button>
                        <!-- <button pButton icon="pi pi-pencil" (click)="openDrawer(role, 'add')" class="p-button-text" *ngIf="canEditGlobalRoles()"></button> -->
                        @if (canDeleteRole(role)) {
                        <button pButton icon="pi pi-trash" (click)="deleteRole(role, '')" class="p-button-text p-button-danger" pTooltip="Delete Role"></button>
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="4" class="text-center py-4">
                        <div class="flex flex-col items-center justify-center space-y-2">
                            <i class="pi pi-inbox text-3xl text-gray-400"></i>
                            <span class="text-gray-500">No global roles found</span>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    }

    <!-- Subscriber Roles Section -->
    <div class="card">
        <div class="flex flex-wrap justify-between items-center mb-3 ">
            @if (currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN') {
            <h3>All Subscribers</h3>
            }
            @if (!(currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN') ) {
            <h3>Roles</h3>
            }
            <div class="flex flex-row flex-wrap gap-2 w-full md:w-auto mt-3 md:mt-0">
                @if ((currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN') && (!(hasSelectedSubscription()))) {
                <p-iconfield iconPosition="left" class="w-full md:w-auto md:mt-0 mt-2">
                    <p-inputicon>
                        <i class="pi pi-search"></i>
                    </p-inputicon>
                                        <input pInputText type="text" placeholder="Search subscribers" i18n-placeholder [(ngModel)]="searchText" (input)="onSearchInput()" class="" fluid>
                </p-iconfield>
                }
                <button pButton label="Add Custom Role" icon="pi pi-plus" (click)="openDrawer(null, 'add')" *ngIf="canAddCustomRole() && hasSelectedSubscription()" class="md:w-auto w-full md:p-button-sm"></button>
            </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="loading" class="flex justify-center items-center py-8">
            <i class="pi pi-spin pi-spinner text-2xl text-blue-500 mr-2"></i>
            <span class="text-gray-600">Loading subscribers...</span>
        </div>
        @if ((!loading) && (currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN')) {
        <p-accordion *ngIf="!loading">
            <p-accordion-panel *ngFor="let subscriber of subscribers; let i = index" [value]="i">
                <p-accordion-header>
                    <div class="flex justify-row gap-2 items-center w-full">
                        <div>
                            <img [src]="subscriber?.companyLogo || 'https://i0.wp.com/sectour.co/wp-content/uploads/2015/04/logo-placeholder.jpg?ssl=1'" alt="Subscriber Logo" i18n-alt class="w-10 h-10 object-contain rounded-lg border border-gray-200 p-1">
                        </div>
                        <div class="flex flex-col">
                            <span class="font-medium">{{ subscriber.companyName }}</span>
                            <span class="text-sm text-gray-500">{{ subscriber.email }}</span>
                        </div>
                    </div>
                </p-accordion-header>
                <p-accordion-content>
                    <div class="space-y-2">
                        <p-table [value]="subscriberRoles[subscriber._id]||[]" [tableStyle]="{'min-width': '50rem'}" [loading]="subscriberRolesLoading" [showLoader]="true">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>ROLE NAME</th>
                                    <th>LEVEL</th>
                                    <th>USERS</th>
                                    <th>ACTIONS</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-role>
                                <tr>
                                    <td>{{ role.name }}</td>
                                    <td>
                                        <p-tag [value]="role.level" severity="info"></p-tag>
                                    </td>
                                    <td>{{ role.userCount || 0 }}</td>
                                    <td>
                                        <button pButton icon="pi pi-eye" (click)="openDrawer(role, 'view')" class="p-button-text"></button>
                                        <!-- <button pButton icon="pi pi-pencil" (click)="openDrawer(role, 'add')" class="p-button-text" *ngIf="!role.locked && canAddCustomRole()"></button> -->
                                        @if (canDeleteRole(role)) {
                                        <button pButton icon="pi pi-trash" (click)="deleteRole(role, subscriber._id)" class="p-button-text p-button-danger" pTooltip="Delete Role"></button>
                                        }
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="4" class="text-center py-4">
                                        <div class="flex flex-col items-center justify-center space-y-2">
                                            <i class="pi pi-inbox text-3xl text-gray-400"></i>
                                            <span class="text-gray-500">No roles found</span>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
        </p-accordion>
        }
        @if ((!loading) && !(currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN')) {
        <div *ngFor="let subscriber of subscribers; let i = index">
            <p-table [value]="subscriberRoles[subscriber._id]||[]" [tableStyle]="{'min-width': '50rem'}" [loading]="subscriberRolesLoading" [showLoader]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>ROLE NAME</th>
                        <th>LEVEL</th>
                        <th>USERS</th>
                        <th>ACTIONS</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-role>
                    <tr>
                        <td>{{ role.name }}</td>
                        <td>
                            <p-tag [value]="role.level" severity="info"></p-tag>
                        </td>
                        <td>{{ role.userCount || 0 }}</td>
                        <td>
                            <button pButton icon="pi pi-eye" (click)="openDrawer(role, 'view')" class="p-button-text"></button>
                            <!-- <button pButton icon="pi pi-pencil" (click)="openDrawer(role, 'add')" class="p-button-text" *ngIf="!role.locked && canAddCustomRole()"></button> -->
                            @if (canDeleteRole(role)) {
                            <button pButton icon="pi pi-trash" (click)="deleteRole(role, subscriber._id)" class="p-button-text p-button-danger" pTooltip="Delete Role"></button>
                            }
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="4" class="text-center py-4">
                            <div class="flex flex-col items-center justify-center space-y-2">
                                <i class="pi pi-inbox text-3xl text-gray-400"></i>
                                <span class="text-gray-500">No roles found</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        }
    </div>
    @if (currentUserRole === 'CSM' || currentUserRole === 'SM' || currentUserRole === 'SUPER_DEV_ADMIN') {
    <div class="card">
        <!-- Pagination -->
        <div class="flex flex-wrap justify-between items-center gap-2 " *ngIf="subscribers.length > 0">
            <div class="text-sm text-gray-600">
                Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ Math.min(currentPage * pageSize, totalSubscribers) }} of {{ totalSubscribers }} entries
            </div>

            <p-paginator [rows]="pageSize" [totalRecords]="totalSubscribers" [rowsPerPageOptions]="pageSizes" (onPageChange)="onPageChange($event)" [showCurrentPageReport]="false">
            </p-paginator>
        </div>
    </div>
    }
</div>

<!-- Right Side Drawer -->
<p-drawer [(visible)]="drawerVisible" [header]="drawerMode === 'view'? 'View Role' : 'Add New Role'" position="right" [baseZIndex]="10000" [modal]="true" styleClass="role-drawer">
    <ng-container *ngIf="drawerMode === 'view' && selectedRole">
        <div class="mb-4">
            <div class="role-header mb-3">
                <h4 class="text-lg font-semibold">{{ selectedRole.name }}</h4>
                <!-- <div class="text-sm text-gray-600">{{ selectedRole.level }} role</div> -->
                <div class="text-sm text-gray-600">Identification: {{ selectedRole.identification }}</div>
            </div>

            <div class="permission-summary mb-4 p-3 bg-gray-50 rounded">
                <div class="text-sm font-medium mb-2">Permission Summary</div>
                <div class="text-sm text-gray-600">
                    {{ selectedRole.permissions.length || 0 }} permissions assigned
                </div>
            </div>
        </div>

        <div class="permissions-section">
            <h5 class="text-md font-medium mb-3">All Permissions</h5>
            <p-accordion>
                <p-accordion-panel *ngFor="let category of permissionCategories; let i = index" [value]="i">
                    <p-accordion-header>
                        <div class="flex justify-between items-center w-full">
                            <span>{{ category }}</span>
                            <span class="text-sm text-gray-500 mr-3">
                                {{ getCategoryPermissionCount(selectedRole, category) }} / {{ permissionsByCategory[category].length }}
                            </span>
                        </div>
                    </p-accordion-header>
                    <p-accordion-content>
                        <div class="space-y-2">
                            <div *ngFor="let perm of permissionsByCategory[category]" class="flex items-center">
                                <p-toggleSwitch [ngModel]="hasPermission(selectedRole!, perm._id)" [disabled]="true" class="mr-2">
                                </p-toggleSwitch>
                                <span class="text-sm">{{ getPermissionDisplayName(perm) }}</span>
                            </div>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
        </div>

        <button pButton label="Close" (click)="closeDrawer()" class="mt-6 w-full"></button>
    </ng-container>
    <ng-container *ngIf="drawerMode === 'add'">
        <form [formGroup]="roleForm" (ngSubmit)="onSubmit()">
            <div class="mb-4">
                <label class="required">Role Name *</label>
                <input pInputText type="text" class="w-full" placeholder="Trainee Field Service Representative" i18n-placeholder formControlName="name" />
                <div *ngIf="roleForm.get('name')?.invalid && roleForm.get('name')?.touched" class="text-red-500 text-sm mt-1">
                    <div *ngIf="roleForm.get('name')?.errors?.['required']" i18n>Role name is required</div>
                    <div *ngIf="roleForm.get('name')?.errors?.['minlength']" i18n>Role name must be at least 3 characters</div>
                </div>
            </div>
            <div class="mb-4">
                <label class="required">Base Role *</label>
                <p-select [options]="availableBaseRoles" placeholder="Select Role" i18n-placeholder formControlName="baseRole"></p-select>
                <div *ngIf="roleForm.get('baseRole')?.invalid && roleForm.get('baseRole')?.touched" class="text-red-500 text-sm mt-1">
                    <div *ngIf="roleForm.get('baseRole')?.errors?.['required']">Base role is required</div>
                </div>
            </div>
            <div class="mb-4">
                <label class="font-medium mb-2 block">Permissions (Based on {{ selectedBaseRole }})</label>
                <p class="text-sm text-gray-600 mb-3">You can only disable permissions from the base role. New permissions cannot be added.</p>
                <p-accordion *ngIf="selectedBaseRole">
                    <p-accordion-panel *ngFor="let category of permissionCategories; let i = index" [value]="i">
                        <p-accordion-header>
                            <div class="flex justify-between items-center w-full">
                                <span class="font-medium">{{ category }}</span>
                                <span class="text-sm text-gray-500 mr-3">
                                    {{ getSelectedPermissionsInCategory(category) }} / {{ getBaseRolePermissionsInCategory(category)?.length || 0 }}
                                </span>
                            </div>
                        </p-accordion-header>
                        <p-accordion-content>
                            <div class="space-y-2">
                                <div *ngFor="let perm of getBaseRolePermissionsInCategory(category)" class="flex items-center">
                                    <p-toggleSwitch [formControl]="getPermissionControl(perm._id)" class="mr-2">
                                    </p-toggleSwitch>
                                    <span class="text-sm">{{ getPermissionDisplayName(perm) }}</span>
                                </div>
                            </div>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
                @if (!selectedBaseRole || !baseRolePermissions[selectedBaseRole].length) {
                <div class="text-gray-500 text-sm">
                    Select a base role to see available permissions
                </div>
                }
            </div>
            <div class="flex gap-2 mt-6">
                <button pButton label="Cancel" class="p-button-outlined w-half" (click)="closeDrawer()" type="button"></button>
                <button pButton label="Save Changes" class="w-half" type="submit" [disabled]="roleForm.invalid"></button>
            </div>
        </form>
    </ng-container>
</p-drawer>

<!-- Toast for messages -->
<p-toast></p-toast>

<!-- Confirmation Dialog -->
<p-confirmDialog></p-confirmDialog>